export default "__VITE_ASSET__DX5Lqs1J__"